import React, { useState, useEffect, useRef, useCallback } from "react";
import MinDataService from "../services/MinService";
import { useParams, useNavigate } from 'react-router-dom';
import TransactionTable from "../../components/TransactionTable";

const MinPr = (props) => {
  const [min, setMin] = useState([]);
  const minRef = useRef();
  minRef.current = min;

  const { owner } = useParams();
  const navigate = useNavigate();

  const retrieveMin = useCallback((ownerParam) => {
    const target = ownerParam ?? owner;
    MinDataService.getAll(target)
      .then((response) => setMin(response.data || []))
      .catch((e) => { console.error(e); setMin([]); });
  }, [owner]);

  useEffect(() => { retrieveMin(); }, [retrieveMin]);

  const deleteMin = useCallback((rowIndex) => {
    const id = minRef.current[rowIndex].id || minRef.current[rowIndex]._id;
    MinDataService.remove(id)
      .then(() => {
        const newArr = [...minRef.current];
        newArr.splice(rowIndex, 1);
        setMin(newArr);
      })
      .catch((e) => console.error(e));
  }, []);

  const handleView = useCallback((row) => {
    const id = row.id || row._id;
    if (id) navigate(`/dashboard/min/${id}`);
  }, [navigate]);

  const handleEdit = useCallback((row) => {
    const id = row.id || row._id;
    if (id) navigate(`/dashboard/min/edit/${id}`);
  }, [navigate]);

  const handleDeleteRow = useCallback((row) => {
    const idx = minRef.current.findIndex(item => (item.id || item._id) === (row.id || row._id));
    if (idx >= 0) deleteMin(idx);
  }, [deleteMin]);

  return (
    <div className="list row">
      <div className="col-md-12 list">
        <TransactionTable
          transactions={min}
          onView={handleView}
          onEdit={handleEdit}
          onDelete={handleDeleteRow}
          initialPageSize={10}
          showBack={true}
          onBack={() => navigate(-1)}
        />
      </div>
    </div>
  );
};

export default MinPr;
